import { Col, Row } from "react-bootstrap";

export default function InputRow({ label, name, register }) {
  function handleRadioClick(e) {
    // onClick({ checked: e.target.checked, name: e.target.name });
  }
  return (
    <Row>
      <Col md={{ offset: 1, span: 4 }}>
        <label>{label}:</label>
      </Col>
      <Col md={6} className="d-md-flex align-items-center">
        <div className="group-wrapper">
          <div className="group-2">
            <label className="radio-container-row">
              <input
                type="radio"
                id={name}
                name={name}
                value="S"
                onClick={handleRadioClick}
                {...register(name)}
              />
              <span className="checkmark-row">S</span>
            </label>
            <label className="radio-container-row">
              <input
                type="radio"
                id={name}
                name={name}
                value="M"
                onClick={handleRadioClick}
                {...register(name)}
              />
              <span className="checkmark-row">M</span>
            </label>
            <label className="radio-container-row">
              <input
                type="radio"
                id={name}
                name={name}
                value="L"
                onClick={handleRadioClick}
                {...register(name)}
              />
              <span className="checkmark-row">L</span>
            </label>
            <label className="radio-container-row">
              <input
                type="radio"
                id={name}
                name={name}
                value="XL"
                onClick={handleRadioClick}
                {...register(name)}
              />
              <span className="checkmark-row">XL</span>
            </label>
            <label className="radio-container-row">
              <input
                type="radio"
                id={name}
                name={name}
                value="XXL"
                onClick={handleRadioClick}
                {...register(name)}
              />
              <span className="checkmark-row">XXL</span>
            </label>
          </div>
        </div>
      </Col>
    </Row>

  );
}
